
import store from '@/store'
import * as apiNote from '@/api/note'
import * as apiCommon from '@/api/common'
import * as _ from 'lodash'
import { breakComma } from '@/util/common'

const getDefaultState = () => {
  const defaults = {
    check: getDefaultCheck(),
    note_num: null,
    note_total_num: null,
    note_search_count: null,
    note_search_private_count: null,
    note_search_share_count: null,
    noteLists: [],
    tagLists: [],
    userLists: [],
    mode: 'detail',
    currentId: null,
    // ログインユーザーと同じ契約に属する全利用者リスト(ノート権限リスト)
    userPermissions: [],
    // 現在選択中(未確定)の共有(閲覧可)利用者リスト
    shareUsersViewable: [],
    // 現在選択中(未確定)の共有(編集可)利用者リスト
    shareUsersEditable: [],
    detail: getDefaultDetail(), // 変更前のデータ
    detailEdit: getDefaultDetail(), // 入力中/編集中のデータ
    overwrite: false, // 更新APIリクエスト時に設定する上書き実行フラグ
    search: {
      id: null,
      keyword: '',
      start: 0,
      per_page: 30,
      search_order: 'date',
      ascending: 'desc',
      pagenate_flg: null,
      user_id: [],
      tags: [],
      is_paginate: 0
    },
    display: {
      title: true,
      content: true,
      created: true,
      modified: true,
      user: true
    },
    complete: false,
    canload: true,
    fileLists: [],
    loading: {
      list: false,
      detail: false,
      user_permissions: false
    },
    auth: false,
    sp_show_pop: false
  }
  return defaults
}

const getDefaultDetail = () => {
  const defaults = {
    title: '',
    create_user_id: null,
    create_user_name: '',
    modified_user_id: null,
    modified_user_name: '',
    user_file_id: null,
    created: null,
    modified: null,
    alert_num: null,
    share_type: 1,
    share_classification: null,
    current_time: null,
    share_users: [],
    tags: [],
    lists: [
      // {
      //   id: null,
      //   rank: null,
      //   type: null,
      //   content: ''
      // }
    ],
    image: null
  }
  return defaults
}

// ノートを編集した場合、遷移前に保存するか否かを確認するための状態変数
const getDefaultCheck = () => {
  const defaults = {
    id: null,
    edited: false,
    linkTo: {
      type: null,
      to: null
    },
    mode: null,
    checkForgetToSave: false,
    forceMove: false
  }

  return defaults
}

const note = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    auth: (state) => state.auth,
    noteCount: (state) => {
      const string = _.isNumber(state.note_search_count)
        ? breakComma(state.note_search_count)
        : ''

      return string
    },
    change: (state) => state.check,
    checkForgetToSave: (state) => state.check.checkForgetToSave,
    isSearch: (state) => {
      return state.search.keyword !== '' ||
        state.search.user_id.length > 0 ||
        state.search.tags.length > 0 ||
        state.search.id > 0
    },
    notelists: (state) => state.noteLists,
    linkTo: (state) => state.check.linkTo,
    filterNotelists: (state) => _.filter(state.noteLists, list => list),
    tagLists: (state) => state.tagLists,
    userLists: (state) => state.userLists,
    currentId: (state) => state.currentId,
    currentList: (state) => _.find(state.noteLists, list => list.id === state.currentId),
    userPermissions: (state) => state.userPermissions,
    shareUsersViewable: (state) => state.shareUsersViewable,
    shareUsersEditable: (state) => state.shareUsersEditable,
    isOwn: (state, getters, rootState) => {
      // 一覧の絞り込みなどにより値が検知できなくなった場合は、詳細から取得する
      const userId = getters.currentList
        ? getters.currentList.create_user_id
        : getters.detail.create_user_id
      return userId === rootState.profile.id
    },
    isEditable: (state, getters) => {
      // 編集可能は、所有者が自分または、編集可で共有されたもの
      return getters.isOwn || (getters.detail.share_type === 2 && getters.detail.share_classification === 22)
    },
    detail: (state) => state.detail,
    detailEdit: (state) => state.detailEdit,
    search: (state) => {
      if (state.search.search_order === 'date' && state.search.ascending === 'desc') return 'date_new'
      else if (state.search.search_order === 'date' && state.search.ascending === 'asc') return 'date_old'
      else if (state.search.search_order === 'name') return 'name'
      else return 'date_new'
    },
    keywordSearchParams: (state, getters) => {
      return {
        id: state.search.id,
        search_text: state.search.keyword,
        user_id: state.search.user_id,
        // tags: getters.getTagIds,
        tags: _.filter(getters.getTagIds, id => _.map(state.tagLists, 'id').includes(id)),
        start: state.search.start,
        per_page: state.search.per_page,
        search_order: state.search.search_order,
        ascending: state.search.ascending,
        is_paginate: state.search.start === 0 ? 0 : 1
      }
    },
    getTagIds: (state) => {
      return _.map(state.search.tags, tag => tag.id)
    },
    sp_show_pop: (state) => {
      return state.sp_show_pop
    }
  },
  mutations: {
    setNoteLists: (state, lists) => {
      state.noteLists.push(...lists)
    },
    setNoteSearchCount: (state, count) => {
      state.note_search_count = count
    },
    setNoteSearchPrivateCount: (state, count) => {
      state.note_search_private_count = count
    },
    setNoteSearchShareCount: (state, count) => {
      state.note_search_share_count = count
    },
    setKeyword: (state, keyword) => {
      state.search.keyword = keyword
    },
    setIncludeId: (state, id) => {
      state.search.id = id
    },
    resetNoteLists: (state, lists) => {
      state.noteLists.splice(0, state.noteLists.length)
    },
    deleteNotelist: (state, index) => {
      state.noteLists.splice(index, 1)
    },
    setStart: (state, num) => {
      state.search.start = num
    },
    resetStart: (state) => {
      state.search.start = 0
    },
    setTagLists: (state, lists) => {
      state.tagLists.splice(0, state.tagLists.length)
      state.tagLists.push(...lists)
    },
    resetTagLists: (state) => {
      state.tagLists.splice(0, state.tagLists.length)
    },
    setUserLists: (state, lists) => {
      state.userLists.splice(0, state.userLists.length)
      state.userLists.push(...lists)
    },
    resetUserLists: (state) => {
      state.userLists.splice(0, state.userLists.length)
    },
    setComplete: (state) => {
      state.complete = true
    },
    resetComplete: (state) => {
      state.complete = false
    },
    setCanload: (state, flg) => {
      state.canload = flg
    },
    setCurrentId: (state, id) => {
      state.currentId = parseInt(id)
    },
    setUserPermissions: (state, userPermissions) => {
      state.userPermissions = userPermissions
    },
    setShareUsersDetail: (state, shareUsers) => {
      state.detail.share_users = shareUsers
    },
    setShareUsersDetailEdit: (state, shareUsers) => {
      state.detailEdit.share_users = shareUsers
    },
    setShareUsersViewable: (state, shareUsersViewable) => {
      state.shareUsersViewable = shareUsersViewable
    },
    setShareUsersEditable: (state, shareUsersEditable) => {
      state.shareUsersEditable = shareUsersEditable
    },
    setUserImage(state, { userFileId, dataUrl }) {
      // 対象のuser_file_idが指定されているリストを取得し、dataUrlを設定する
      const setThisFileLists = _.filter(state.noteLists, list => list.user_file_id === userFileId)
      _.forEach(setThisFileLists, list => {
        const index = state.noteLists.findIndex((u) => u.id === list.id)
        const prevList = state.noteLists[index]
        prevList.image = dataUrl
        state.noteLists.splice(index, 1, prevList)
      })
    },
    setOrder(state, { searchOrder, ascending }) {
      state.search.search_order = searchOrder
      state.search.ascending = ascending
    },
    setDisplay(state, display) {
      Object.assign(state.display, display)
    },
    setDetail(state, data) {
      
      state.detail.title = data.title
      state.detail.create_user_id = data.create_user_id
      state.detail.create_user_name = data.create_user_name
      state.detail.modified_user_id = data.modified_user_id
      state.detail.modified_user_name = data.modified_user_name
      state.detail.user_file_id = data.user_file_id
      state.detail.created = data.created
      state.detail.modified = data.modified
      state.detail.alert_num = data.alert_num
      state.detail.share_type = data.share_type
      state.detail.share_classification = data.share_classification
      state.detail.current_time = data.current_time

      // 印刷タイトルを設定
      store.dispatch('print/setTitle', data.title)

      // リストは一度削除してから入れなおす
      state.detail.tags.splice(0, state.detail.tags.length)
      state.detail.tags.push(...data.tags)
      state.detail.lists.splice(0, state.detail.lists.length)
      state.detail.lists.push(...data.lists)

      // 編集差分をとりたいので、編集用のオブジェクトを準備
      state.detailEdit = _.cloneDeep(state.detail)
    },
    // 編集差分をlogic内の処理で変更する場合に使用する
    setDetailEditValue(state, { key, value }) {
      state.detailEdit[key] = value
    },
    setDetailUserImage(state, { dataUrl }) {
      state.detail.image = dataUrl
    },
    // 更新APIリクエスト時に設定する上書き実行フラグ
    setOverwrite(state, overwrite) {
      state.overwrite = overwrite
    },
    loadingList(state, flg) {
      state.loading.list = flg
    },
    loadingDetail(state, flg) {
      state.loading.detail = flg
    },
    loadingUserPermissions(state, flg) {
      state.loading.user_permissions = flg
    },
    resetDetail(state) {
      state.currentId = null
      Object.assign(state.detail, getDefaultDetail())
      Object.assign(state.detailEdit, getDefaultDetail())
    },
    setNarrowUsers(state, lists) {
      state.search.user_id.splice(0, state.search.user_id.length)
      state.search.user_id.push(..._.filter(lists, id => id >= -1))
    },
    setNarrowTags(state, lists) {
      state.search.tags.splice(0, state.search.tags.length)
      state.search.tags.push(...lists)
    },
    resetNarrowUsers(state) {
      state.search.user_id.splice(0, state.search.user_id.length)
    },
    resetNarrowTags(state) {
      state.search.tags.splice(0, state.search.tags.length)
    },
    resetAll(state) {
      Object.assign(state, getDefaultState())
    },
    noteEdited(state, data) {
      const { id, edited } = data
      state.check.id = id
      state.check.edited = edited
    },
    modeChange(state, mode) {
      state.check.mode = mode
      state.mode = mode
    },
    checkForgetToSave(state, flg) {
      state.check.checkForgetToSave = flg
    },
    setLinkTo(state, data) {
      const { type, to } = data
      state.check.linkTo.type = type
      state.check.linkTo.to = to
    },
    resetLinkTo(state) {
      state.check.linkTo.type = null
      state.check.linkTo.to = null
    },
    forceMove(state) {
      state.check.forceMove = true
    },
    resetCheck(state) {
      Object.assign(state.check, getDefaultCheck())
    },
    setAuth(state, flg) {
      state.auth = flg
    },
    setSPShowPop(state, flg) {
      state.sp_show_pop = flg
    }
  },
  actions: {
    resetAllState: ({ commit }) => {
      commit('resetAll')
    },
    noteEdited: ({ commit }, data) => {
      commit('noteEdited', data)
    },
    getNoteCount: ({ commit, getters }) => {
      const params = getters.keywordSearchParams
      apiNote
        .count(params)
        .then(res => {
          const { data } = res
          if (data.status === 0) {
            commit('setNoteSearchCount', data.count)
            commit('setNoteSearchPrivateCount', data.private_count)
            commit('setNoteSearchShareCount', data.share_count)
          } else {
            throw res
          }
        })
    },
    getNoteLists: async ({ commit, state, dispatch, getters }) => {
      const params = getters.keywordSearchParams
      if (state.canload) {
        commit('setCanload', false)
        commit('loadingList', true)
        await apiNote
          .list(params)
          .then(async (response) => {
            const { data } = response
            if (data.status === 0) {
              const { lists } = data
              if (lists && lists.length > 0) {
                const start = state.search.start + lists.length
                // 返却されたリストの数が指定数よりも小さければ全読み込み完了
                if (lists.length < params.per_page) await commit('setComplete')
                // すでにリストに読み込み済みのものは除外
                const currentIds = _.map(state.noteLists, list => list.id)
                const excludeCurrentList = _.reject(lists, list => currentIds.includes(list.id))
                commit('setStart', start)
                commit('setNoteLists', excludeCurrentList)

                // 初期アクティブにするリストを設定
                if (!state.currentId) {
                  const currentId = _.get(state.noteLists, '[0].id')
                  commit('setCurrentId', currentId)
                }
                commit('setCanload', true)

                // 画像設定しているユーザーのアイコンを設定する
                // すべてループで回すと処理が遅いため、user_file_id毎にまとめて処理する
                const settingImageLists = _.filter(lists, list => list.user_file_id && list.user_file_id > 0)
                const userFileIds = _.uniq(_.map(settingImageLists, list => list.user_file_id))
                _.forEach(userFileIds, userFileId => {
                  dispatch('getFile', userFileId, { root: true }).then(res => {
                    commit('setUserImage', {
                      userFileId: userFileId,
                      dataUrl: res.dataUrl
                    })
                  })
                })
              } else {
                commit('setCanload', true)
                commit('loadingList', false)
                commit('setComplete')
              }
              commit('setAuth', true)
            } else {
              // ノートへのアクセス件がない場合
              if (data.status === 400 && data.error_message === '権限が無い為、ご利用になれません。') {
                commit('setAuth', false)
              }
              commit('setCanload', true)
              commit('loadingList', false)
              commit('setComplete')
            }
          })
      }
    },
    resetNoteLists: ({ commit }) => {
      commit('resetNoteLists')
    },
    getTags: async ({ state, commit }) => {
      const params = {
        search_text: state.search.keyword,
        id: state.search.id
      }
      await apiNote
        .listNoteTags(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            const { tags } = data
            commit('setTagLists', tags)
          }
        })
    },
    getUserLists({ state, commit, rootState }) {
      const params = {
        search_text: state.search.keyword,
        id: state.search.id
      }
      apiNote
        .listUsers(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            const { users } = data
            // 自身のIDを除外する
            // const myId = rootState.profile.id ?? 0
            // const others = _.reject(users, user => user.id === myId)
            commit('setUserLists', users)
          }
        })
    },
    setNarrowTags({ commit }, tags) {
      commit('setNarrowTags', tags)
    },
    setNarrowUsers({ commit }, users) {
      commit('setNarrowUsers', users)
    },
    resetNarrowTags({ commit }) {
      commit('resetNarrowTags')
    },
    resetNarrowUsers({ commit }) {
      commit('resetNarrowUsers')
    },
    setKeyword({ commit }, keyword) {
      commit('setKeyword', keyword)
    },
    setIncludeId: ({ commit }, id) => {
      commit('setIncludeId', id)
    },
    setCurrentId({ commit }, id) {
      commit('setCurrentId', id)
    },
    setUserPermissions({ commit }, userPermissions) {
      commit('setUserPermissions', userPermissions)
    },
    setShareUsersDetail({ commit }, shareUsers) {
      commit('setShareUsersDetail', shareUsers)
    },
    setShareUsersDetailEdit({ commit }, shareUsers) {
      commit('setShareUsersDetailEdit', shareUsers)
    },
    // 現在選択中(未確定)の共有(閲覧可)利用者リスト
    setShareUsersViewable({ commit }, shareUsersViewable) {
      commit('setShareUsersViewable', shareUsersViewable)
    },
    // 現在選択中(未確定)の共有(編集可)利用者リスト
    setShareUsersEditable({ commit }, shareUsersEditable) {
      commit('setShareUsersEditable', shareUsersEditable)
    },
    async getOrder({ commit, dispatch, rootState }) {
      const { common: { device } } = rootState
      await apiCommon
        .fetchUserSetting({ setting_key: `${device}_note_order_settings` })
        .then(async(response) => {
          const { data } = response
          if (data && data.status === 0) {
            if (data.setting_value) {
              const settingValue = JSON.parse(data.setting_value)
              commit('setOrder', settingValue)
            }
          }
        })
    },
    setOrder({ commit, rootState }, order) {
      const { common: { device } } = rootState
      const settingValue = {}

      if (order === 'date_new') {
        settingValue.searchOrder = 'date'
        settingValue.ascending = 'desc'
      } else if (order === 'date_old') {
        settingValue.searchOrder = 'date'
        settingValue.ascending = 'asc'
      } else if (order === 'name') {
        settingValue.searchOrder = 'name'
        settingValue.ascending = 'asc'
      } else {
        settingValue.searchOrder = 'date'
        settingValue.ascending = 'desc'
      }

      const params = {
        setting_key: `${device}_note_order_settings`,
        setting_value: settingValue
      }

      apiCommon
        .updateUserSetting(params)
        .then(response => {
          const data = response.data
          if (data.status === 0) {
            commit('setOrder', settingValue)
          } else {
            throw response
          }
        })
    },
    async getDisplay({ commit, dispatch, rootState }) {
      const { common: { device } } = rootState
      await apiCommon
        .fetchUserSetting({ setting_key: `${device}_note_display_settings` })
        .then(async (response) => {
          const { data } = response
          if (data && data.status === 0) {
            if (data.setting_value) {
              const settingValue = JSON.parse(data.setting_value)
              commit('setDisplay', settingValue)
            }
          }
        })
    },
    setDisplay({ commit, rootState, state }, display) {
      const { common: { device } } = rootState
      const settingValue = display
      const params = {
        setting_key: `${device}_note_display_settings`,
        setting_value: settingValue
      }

      apiCommon
        .updateUserSetting(params)
        .then(response => {
          const data = response.data
          if (data.status === 0) {
            commit('setDisplay', settingValue)
          } else {
            throw response
          }
        })
    },
    reset: async ({ commit }) => {
      await commit('setStart', 0)
      commit('resetNoteLists')
      // commit('resetNarrowTags')
      // commit('resetNarrowUsers')
      // commit('setCurrentId', null)
      commit('resetComplete')
    },
    getDetail: async ({ commit, state, dispatch }) => {
      const params = {
        id: state.currentId
      }
      commit('loadingDetail', true)
      await apiNote
        .detail(params)
        .then(async(response) => {

          const { data } = response
          if (data.status === 0) {
            const save = _.cloneDeep(data)
            save.lists = _.forEach(save.lists, list => {
              if (list.type === 3) {
                list.qa.pdfLink = apiCommon.getFetchFileAPIURL(list.qa.file_id, false)
              }
            })

            delete save.status
            delete save.error_message

            commit('loadingDetail', false)

            if (state.mode === 'create') {
              // 新規作成の場合
              // ※注：ノート一覧表示時処理で最初の詳細を取得するために本メソッドを呼び詳細APIをコールするが、
              // その詳細APIのレスポンス待ちの時に「ノートの新規作成」ボタンを押下すると(mode='create'に変更すると)、
              // 新規作成なのに、ノート詳細が表示されてしまう問題が発生する。
              // よって、詳細API受信時にmode='create'になっている場合は詳細を設定しない。
            } else {
              // 新規作成以外の場合

              // 受信したノート詳細データを設定する
              commit('setDetail', save)

              save.user_file_id > 0 && dispatch('getFile', save.user_file_id, { root: true }).then(res => {
                commit('setDetailUserImage', {
                  dataUrl: res.dataUrl
                })
              })

              store.dispatch('common/addTitle', save.title + '-')
            }

            // 詳細APIを実行するときは、ノート利用者権限一覧APIも必ずリクエストする
            // ※新規作成の場合（mode='create'）も、共有できる利用者を知るために（共有エリア表示判定のために）リクエストする
            await store.dispatch('note/getUserPermissions', { isShareUsersSet: true })
          } else {
            // 対象ノートが閲覧できなくなった場合（例：共有権限を剥奪された場合）エラー表示
            if (typeof data.error_message !== 'undefined') {
              store.dispatch('common/showNotice', { title: 'エラー', text: data.error_message })
            }
          }
        })
        .finally(() => {
          commit('loadingDetail', false)
        })
    },
    /**
     * ノート利用者権限一覧を取得
     * @param {*} param0 
     * @param {*} isShareUsersSet DBに保存されている選択ユーザーをshare_usersを設定する場合はtrue
     */
    getUserPermissions: async ({ commit, state }, { isShareUsersSet }) => {

      commit('loadingUserPermissions', true)

      // ノート利用者権限一覧APIをコール
      const params = {}
      if (state.currentId) {
        params.id = state.currentId
      }
      await apiNote
        .getUserPermissions(params)
        .then(response => {
          const { data } = response

          if (data.status === 0) {
            const users = data.users

            // ノート詳細からshare_classificationを取得（APIレスポンスに含まれていない場合の補完用）
            const noteShareClassification = state.detail.share_classification
            const noteShareType = state.detail.share_type

            const userPermissions = []
            const shareUsers = []
            const shareUsersViewable = []
            const shareUsersEditable = []
            for (let i = 0; i < users.length; i++) {
              // APIレスポンスでは integrated_user_id が使われているため、id にマッピング
              const id = users[i].integrated_user_id || users[i].id
              // share_classificationがnull/undefinedで、かつ共有タイプ（share_type=2）の場合、
              // ノート詳細のshare_classificationを使用して補完
              let type = users[i].share_classification
              if ((type === null || type === undefined) && noteShareType === 2 && noteShareClassification !== null && noteShareClassification !== undefined) {
                type = noteShareClassification
              }

              // 【注意】ここで自分(ログインユーザー)を除外する処理はしない。
              // ・編集権限ユーザーの場合に権限が外れたり、
              //   「保存」ボタンのアクティブ判定が正常にできなくなるため。
              // ・画面に自分(ログインユーザー)を含めない処理はビュー側で行う

              // id プロパティを追加して userPermissions に push
              const userPermission = {
                ...users[i],
                id: id
              }
              userPermissions.push(userPermission)

              const map = {
                id: id,
                type: type
              }
              if (type === 21) {
                // 閲覧可の場合
                shareUsers.push(map)
                shareUsersViewable.push(map)
              } else if (type === 22) {
                // 編集可の場合
                shareUsers.push(map)
                shareUsersEditable.push(map)
              }
            }

            commit('setUserPermissions', userPermissions)

            if (isShareUsersSet) {
              commit('setShareUsersDetail', shareUsers)
              commit('setShareUsersDetailEdit', shareUsers)
              commit('setShareUsersViewable', shareUsersViewable)
              commit('setShareUsersEditable', shareUsersEditable)
            }
          }
        })
        .finally(() => {
          commit('loadingUserPermissions', false)
        })
    },
    resetStart: ({ commit }) => {
      commit('resetStart')
    },
    resetDetail: ({ commit }) => {
      commit('resetDetail')
    },
    resetUserPermissions: ({ commit }) => {
      commit('setUserPermissions', [])
    },
    resetShareUsers: ({ commit }) => {
      commit('setShareUsersDetail', [])
      commit('setShareUsersDetailEdit', [])
      commit('setShareUsersViewable', [])
      commit('setShareUsersEditable', [])
    },
    // 編集差分をlogic内の処理で変更する場合に使用する
    setDetailEditValue: ({ commit }, { key, value }) => {
      commit('setDetailEditValue', { key, value })
    },
    // 更新APIリクエスト時に設定する上書き実行フラグ
    setOverwrite({ commit }, overwrite) {
      commit('setOverwrite', overwrite)
    },
    copyNote: async ({ state, getters, commit }) => {
      const id = getters.currentId
      await apiNote
        .copy({
          id: id
        })
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            // 複製したノートを選択状態にする
            commit('setCurrentId', data.id)
          }
        })
        .finally(r => {
          return r
        })
    },
    deleteNote: async ({ state, getters, commit }) => {
      const id = getters.currentId
      await apiNote
        .remove({
          id: id
        })
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            const targetListNumber = _.findIndex(state.noteLists, list => list.id === id)
            commit('deleteNotelist', targetListNumber)
            commit('setStart', state.search.start--)

            // 削除後はリスト先頭を選択状態にする
            const currentId = _.get(state.noteLists, '[0].id')
            commit('setCurrentId', currentId)
          }
        })
    },
    /**
     * ノートを編集した場合、遷移前に保存するか否かを確認するための状態
     */
    modeChange: ({ commit }, mode) => {
      commit('modeChange', mode)
    },
    // 編集忘れ確認ダイアログを表示
    showDialogToPreventForgettingToSave: ({ commit }) => {
      commit('checkForgetToSave', true)
    },
    // 編集忘れ確認ダイアログを消す
    hideDialogToPreventForgettingToSave: ({ commit }) => {
      commit('checkForgetToSave', false)
    },
    setLinkTo: ({ commit }, data) => {
      commit('setLinkTo', data)
    },
    resetLinkTo: ({ commit }) => {
      commit('resetLinkTo')
    },
    forceMove: ({ commit }) => {
      commit('forceMove')
    },
    resetCheck: ({ commit }) => {
      commit('resetCheck')
    },
    spShowPop: ({ commit }, flg) => {
      commit('setSPShowPop', flg)
    }
  }
}

export default note
